<template>
<div class="animated fadeIn" @keyup.esc="cancelWto">
    <b-row>
        <b-col sm="12">
            <b-card v-if="!isWTORetrieved">
                <div slot="header">
                    <strong>{{title}}</strong>
                </div>
                <b-row>
                    <b-col sm="12">
                        <b-form-group name="wto" label="WTO No" label-for="elementsPrependAppend" description="">
                            <b-input-group>
                                <wtoLookup style="min-width:300px" v-bind:url="apiWtoLookup" v-on:selected="setWtoId($event)" :basic="1" ref="wtoLookupInput" :lookupId="wtr.wto_num"/>&nbsp;&nbsp;&nbsp;
                                <b-button variant="primary" @click="retrieveWTO" :disabled="wtr.wto_num ==''">Retrieve WTO</b-button>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
            <b-card v-if="isWTORetrieved">
                    <div slot="header">
                        <strong>{{title}}</strong>
                    </div>
                    <b-row>
                        <b-col>
                            <b-row>
                                <b-col sm="12">
                                    <b-form-group>
                                        <label for="wtr_date">WTR Date</label>
                                            <b-form-input type="date" id="wtr_date" v-model="wtr.wtr_date"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="12">
                                    <label for="remarks">WTR Remarks</label>
                                        <textarea class="form-control" rows="5" id="remarks" v-model="wtr.remarks"></textarea>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="12">
                                    <label for="reference_num">Reference Number</label>
                                        <b-form-input type="text" id="reference_num" v-model="wtr.reference_num"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col v-if="wtr.wto.wtrs.length > 0" sm="6">
                            <br/>
                            <b-card>
                                <div class="table-responsive">
                                    <table>
                                        <thead>
                                            <th style="min-width:138px;height:40px">WTR No</th>
                                            <th style="min-width:100px">Date</th>
                                            <th>Generated By</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row, index in wtr.wto.wtrs" :ref="'title'" style="height:40px">
                                                <td>
                                                    <b-button type="submit" size="md" variant="primary" @click="printWTR(row)">{{row.wtr_num}} </b-button>
                                                </td>
                                                <td>{{row.wtr_date_friendly}}</td>
                                                <td>{{row.author_user_shortname}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>
                    <br/>
                    <hr>
                    <br/>
                    <b-row>
                        <b-col sm="4">
                            <b-form-group>
                                <label for="wto_num">WTO No</label>
                                    <b-form-input type="text" v-model="wtr.wto_num" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="wto_date">WTO Date</label>
                                    <b-form-input type="date" v-model="wtr.wto.wto_date" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="status">Status</label>
                                    <b-form-input type="text" v-model="wtr.wto.status" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="reason">Reason</label>
                                        <b-form-input type="text" v-model="wtr.wto.reason" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="location_from">Location From (Warehouse)</label>
                                        <b-form-input type="text" v-model="wtr.wto.from_location_full" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="location">Receiving Warehouse</label>
                                        <b-form-input type="text" v-model="wtr.wto.to_location_full" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <label for="remarks">WTO Remarks</label>
                                    <textarea class="form-control" rows="5" id="remarks" v-model="wtr.wto.remarks" disabled></textarea>
                            </b-col>
                        </b-row>
                </b-card>
        </b-col>
    </b-row>
    <b-row v-if="isWTORetrieved">
        <b-col sm="12">
            <b-card>
                <div slot ="header">
                    <strong>WTR Items</strong>
                </div>
                <div class="table-responsive">
                    <table class='table table-striped table-bordered'>
                        <thead>
                            <th style="width:10px">S/N</th>
                            <th style="min-width:300px">Product Name</th>
                            <th width="150px">Product Code</th>
                            <th width="150px">SOH</th>
                            <th width="180px">Requested Qty</th>
                            <th width="180px">Received Qty</th>
                            <th width="180px">Update Qty</th>
                        </thead>
                        <tbody>
                            <tr v-for="row, index in wtr.wto.wto_items" >
                                <td>{{(index*1) + 1}}</td>
                                <td>{{row.product_name}}</td>
                                <td>{{row.product_id}}</td>
                                <td>{{(row.qty_to_soh*1) + (row.qty_received_current*1)}}</td>
                                <td>{{row.qty*1}}</td>
                                <td>{{row.qty_received*1}}</td>
                                <td><input type="number" name="received_qty" v-model= "row.qty_received_current" class="form-control" :disabled="wtr.wto.status != 'OPEN' || (row.qty * 1) - (row.qty_received * 1) <= 0"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="isWTORetrieved" style="padding:0px 0px 20px 18px">
            <b-button type="submit" size="lg" variant="primary" @click="confirmSave" v-if="wtr.wto.status == 'OPEN' && isWtrAdmin">Save WTR</b-button>
            <b-modal v-model="modalShow" @ok="save"  title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                <p style="color:darkblue">Confirmed Save?</p>
            </b-modal>
            <b-modal v-model="modalCancelShow" @ok="cancel"  title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                <p style="color:darkblue">Confirmed Cancel?</p>
            </b-modal>
            <b-modal ref="myModalRef" hide-header-close hide-footer title="Warehouse Transfer Receiving" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                    <div class="d-block text-center">
                        <p>Warehouse Transfer Receiving <strong style="color:green"> {{wtrDocNo}}</strong> is saved.<br/><br/></p>
                    </div>
                        <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
            </b-modal>
            <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
                <div class="d-block text-center">
                    <p style="color:red">{{errorMessage}}</p>
                </div>
                <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
            </b-modal>
            &nbsp;&nbsp;
            <b-button type="button" size="lg" variant="danger" @click="confirmCancel" v-if="wtr.wto.status == 'OPEN'">Cancel</b-button>
            <b-button type="button" size="lg" variant="success" @click="print" v-if="wtr.wto.status == 'CLOSE' || wtr.wto.status == 'MANUAL-CLOSED'">Print</b-button>&nbsp;&nbsp;
            <b-button type="button" size="lg" variant="danger" @click="back" v-if="wtr.wto.status == 'CLOSE' || wtr.wto.status == 'MANUAL-CLOSED'">Back</b-button>
    </b-row>
</div>
</template>
<script>
import axios from 'axios'
import wtoLookup from '@/components/Autocomplete.vue'
import {authHeader, apiWtoLookup, apiwtrsave, apiWtrSave,apiCountryLookup} from '@/functions/common.vue'
import productLookup from '@/components/Autocomplete.vue'
import pdfMake from "pdfmake/build/pdfmake";
    import pdfFonts from "pdfmake/build/vfs_fonts";
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
        "ukai": {
            normal: 'ukai.ttf',
            bold: 'ukai.ttf',
            italics: 'ukai.ttf',
            bolditalics: 'ukai.ttf'
        },
    };
export default
{
    name: 'wtr',
    components: {wtoLookup},
    data: () => {
        return {
            wtoNum: '',
            modalMsg: '',
            isWTORetrieved: false,
            isWtrAdmin: false,
            modalShow:false,
            modalCancelShow:false,
            title:'New WTR',
            errorMessage:'',
            apiWtoLookup : apiWtoLookup,
            wtrDocNo :'test',
            isValid : true,
            received_qty:0,
            country_name:'',
            wtr:
            {
                wtr_num: '',
                wtr_date: '',
                wto_num:'',
                remarks:'',
                reference_num:'',
                wtr_items:{},
                wto: {
                    wtrs:{}
                }
            },
        }
    },
    created: function()
    {
        var app_role

        app_role = JSON.parse(localStorage.getItem('app_role'))
        this.isWtrAdmin = app_role.includes('WTR_ADMIN')

        if (localStorage.getItem("wtr_new.wto_num") != "")
        {
            this.isWTORetrieved = true
            var wtoNum = localStorage.getItem("wtr_new.wto_num")
            var url = this.apiWtoLookup

            axios.get(url, {params: {q: wtoNum, get:1}},authHeader())
            .then(response =>
            {
                this.list = response.data.data.list
                if (this.list.length>0)
                {
                    this.item = this.list[0]
                    if (this.item !== null)
                    {
                        this.isWTORetrieved = true

                        var wto = this.item
                        console.log(wto)
                        if(wto.country_id != null)
                            {
                                axios.get(apiCountryLookup, {params: {q: wto.country_id}})
                                    .then(response =>
                                    {

                                        if (response.data != null)
                                        {
                                            this.list = response.data.data.list
                                            this.item = this.list[0]
                                            this.country_name = this.item.country_name
                                            this.country_name = this.country_name.toUpperCase()
                                        }
                                    })
                            }
                        let curDate = new Date()
                        curDate = curDate.toISOString().substr(0,10)
                        this.wtr.wtr_date = curDate
                        this.wtr.wto = wto
                        this.wtr.wto_num = wto.wto_num
                    }
                }
            })
            .catch(error => alert(error))
        }
        else
        {
            this.isWToRetrieved = false
            this.wtrNum = ''
        }

    },
    methods:
    {
        printWTR(row)
            {
                    var wtr_num = row.wtr_num
                    var r = []
                    var wtrItems = []
                    r = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'Product Code',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                    ]
                    wtrItems.push(r)

                    var items = row.wtr_items
                    for (let key in items) {
                        var data = items[key]
                        var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        if (data.product_name == null)
                        {
                            data.product_name = ""
                        }
                        r = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: data.product_id,
                                style: 'itemText'
                            },
                            {
                                text: data.product_name,
                                style: 'itemText'
                            },
                            {
                                text: qty,
                                style: 'itemNumber'
                            },
                        ]
                        wtrItems.push(r)
                    }

                    var ddHeader = {
                        columns: [
                            [{
                                    text: 'ELKEN ' + this.country_name+' WAREHOUSE TRANSFER RECEIVING',
                                    style: 'invoiceTitle',
                                    width: '*'
                                },
                                {
                                    stack: [
                                        {
                                            columns: [
                                                {
                                                    text: 'WTR #',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: wtr_num,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [

                                                {
                                                    text: 'WTR Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: row.wtr_date_friendly,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Reference WTO #',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: row.wto_num,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Location From (Warehouse)',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wtr.wto.from_location_full,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Receiving Warehouse',
                                                    style: 'invoiceSubTitle',
                                                    width: 150

                                                },
                                                {
                                                    text: this.wtr.wto.to_location_full,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },

                                    ]
                                }
                            ],
                        ],
                    }

                    var dd = {
                        header: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 10, 0, 0],
                                columns: [{
                                        text: '',
                                        style: 'documentHeaderLeft'
                                    },
                                    {
                                        text: wtr_num,
                                        style: 'documentHeaderCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentHeaderRight'
                                    }
                                ]
                            }
                        },
                        footer: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 0, 0, 50],
                                columns: [{
                                        text: '',
                                        style: 'documentFooterLeft'
                                    },
                                    {
                                        text: 'Page ' + pageNumber + " of " + pageCount,
                                        style: 'documentFooterCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentFooterRight'
                                    }
                                ]
                            };
                        },
                        content: [
                            ddHeader,
                            // Line breaks
                            '\n\n',
                            {
                                layout: 'lightHorizontalLines',
                                table: {

                                    headerRows: 1,
                                    widths: [25, 68, '*', 45, 45],
                                    body: wtrItems

                                }, // table
                            },
                            {
                                text: 'Remarks',
                                style: 'notesTitle'
                            },
                            {
                                text: row.remarks,
                                style: 'notesText'
                            },
                            {
                                columns: [
                                        {
                                            stack: [
                                                {
                                                    text: 'Received By',
                                                    style:'signaturePlaceholder'
                                                },

                                                {
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                {
                                                    text: 'Name  :',
                                                    style:'signatureName'

                                                },
                                                {
                                                    text: 'Date  :',
                                                    style:'signatureJobTitle'

                                                }
                                                ],
                                                width: 160
                                        }

                                    ]
                            },
                        ],
                        styles: {
                            // Document Header
                            documentHeaderLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentHeaderCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentHeaderRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Document Footer
                            documentFooterLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentFooterCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentFooterRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Invoice Title
                            invoiceTitle: {
                                fontSize: 20,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 15]
                            },
                            // Invoice Details
                            invoiceSubTitle: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            invoiceSubValue: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            // Billing Headers
                            invoiceBillingTitle: {
                                fontSize: 14,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 20, 0, 5],
                            },
                            // Billing Details
                            invoiceBillingDetails: {
                                alignment: 'left'

                            },
                            invoiceBillingAddressTitle: {
                                margin: [0, 7, 0, 3],
                                bold: true
                            },
                            invoiceBillingAddress: {

                            },
                            // Items Header
                            itemsHeader: {

                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true
                            },
                            // Item Title
                            itemTitle: {
                                bold: true,
                            },
                            itemSubTitle: {
                                //italics: true,
                                fontSize: 10
                            },
                            itemText: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                            },
                            itemNumber: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'right',
                            },
                            itemTotal: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },

                            // Items Footer (Subtotal, Total, Tax, etc)
                            itemsFooterSubTitle: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterSubValue: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            itemsFooterTotalTitle: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterTotalValue: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            signaturePlaceholder: {
                                fontSize: 10,
                                margin: [0, 70, 0, 0],
                            },
                            signatureName: {
                                fontSize: 10,
                                margin: [0, 10, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            signatureJobTitle: {
                                fontSize: 10,
                                margin: [0, 20, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            notesTitle: {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 30, 0, 3],
                            },
                            notesText: {
                                fontSize: 10
                            },
                            center: {
                                alignment: 'center',
                            },
                        },
                        defaultStyle: {
                            columnGap: 20,
                            font:'ukai'
                        }
                    }
                    pdfMake.createPdf(dd).open();
        },
        print()
            {
                console.log(this.wtr.wto)
                    var wtoNum = this.wtr.wto_num
                    var row = []
                    var date = new Date(this.wtr.wto.wto_date)
                    var wtoDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    var wtoItems = []
                    row = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'Product Code',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'WTO Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                        {
                            text:'Received Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        }
                    ]
                    wtoItems.push(row)
                    var items = this.wtr.wto.wto_items
                    for (let key in items)
                    {
                        var data = items[key]
                        var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var qty_received = (data.qty_received* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        if (data.product_name == null)
                        {
                            data.product_name = ""
                        }
                        row = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: data.product_id,
                                style: 'itemText'
                            },
                            {
                                text: data.product_name,
                                style: 'itemText'
                            },
                            {
                                text: qty,
                                style: 'itemNumber'
                            },
                            {
                                text: qty_received,
                                style: 'itemNumber'
                            },
                        ]
                        wtoItems.push(row)
                    }
                    var wtrItems = []
                    var wtrsRow = []
                    wtrsRow = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'GRN #',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'GRN Date',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Generated By',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },

                    ]
                   wtrItems.push(wtrsRow)
                    var wtrs = this.wtr.wto.wtrs
                    for (let key in wtrs) {
                        var gd = wtrs[key]
                        wtrsRow = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: gd.wtr_num,
                                style: 'itemText'
                            },
                            {
                                text:gd.wtr_date_friendly,
                                style: 'itemText'
                            },
                            {
                                text: gd.author_user_shortname,
                                style: 'itemText'
                            },

                        ]
                        wtrItems.push(wtrsRow)
                    }

                    var ddHeader = {
                        columns: [
                            [{
                                    text: 'ELKEN ' + this.country_name+' WAREHOUSE TRANSFER RECEIVING',
                                    style: 'invoiceTitle',
                                    width: '*'
                                },
                                {
                                    stack: [{
                                            columns: [
                                                {
                                                    text: 'WTO #',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: wtoNum,
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                                {text: '',style:'invoiceSubValue',width: 40},
                                                {
                                                    text: 'WTO Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 80

                                                },
                                                {
                                                    text: wtoDate,
                                                    style: 'invoiceSubValue',
                                                    width: 130

                                                },
                                            ]
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Location From',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: this.wtr.wto.from_location_full,
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                                {text: '',style:'invoiceSubValue',width: 40},
                                                {
                                                    text: 'Location To',
                                                    style: 'invoiceSubTitle',
                                                    width: 80

                                                },
                                                {
                                                    text: this.wtr.wto.to_location_full,
                                                    style: 'invoiceSubValue',
                                                    width: 'auto'
                                                },
                                            ]

                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Status',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: this.wtr.wto.status,
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                                {text: '',style:'invoiceSubValue',width: 40},
                                                {
                                                    text: 'Reason',
                                                    style: 'invoiceSubTitle',
                                                    width: 80

                                                },
                                                {
                                                    text: this.wtr.wto.reason,
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                            ]

                                        },
                                    ]
                                }
                            ],
                        ],
                    }

                    var dd = {
                        header: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 10, 0, 0],
                                columns: [{
                                        text: '',
                                        style: 'documentHeaderLeft'
                                    },
                                    {
                                        text: wtoNum,
                                        style: 'documentHeaderCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentHeaderRight'
                                    }
                                ]
                            }
                        },
                        footer: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 0, 0, 50],
                                columns: [{
                                        text: '',
                                        style: 'documentFooterLeft'
                                    },
                                    {
                                        text: 'Page ' + pageNumber + " of " + pageCount,
                                        style: 'documentFooterCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentFooterRight'
                                    }
                                ]
                            };
                        },
                        content: [
                            ddHeader,
                            // Line breaks
                            {
                                text: 'WTR Lists',
                                style: 'notesTitle'
                            },
                            {
                            table: {
                                // headers are automatically repeated if the table spans over multiple pages
                                // you can declare how many rows should be treated as headers
                                headerRows: 0,
                                widths: [25,'auto',80,'auto'],
                                body: wtrItems
                            }, // table
                            layout: 'lightHorizontalLines'
                            },
                            '\n\n',
                            {
                                layout: 'lightHorizontalLines',
                                table: {

                                    headerRows: 1,
                                    widths: [25, 68, '*', 65, 65],
                                    body: wtoItems

                                }, // table
                            },
                            {
                                text: 'WTO Remarks',
                                style: 'notesTitle'
                            },
                            {
                                text: this.wtr.wto.remarks,
                                style: 'notesText'
                            },
                        ],
                        styles:
                        {
                            // Document Header
                            documentHeaderLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentHeaderCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentHeaderRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Document Footer
                            documentFooterLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentFooterCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentFooterRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Invoice Title
                            invoiceTitle: {
                                fontSize: 20,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 15]
                            },
                            // Invoice Details
                            invoiceSubTitle: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            invoiceSubValue: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            // Billing Headers
                            invoiceBillingTitle: {
                                fontSize: 14,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 20, 0, 5],
                            },
                            // Billing Details
                            invoiceBillingDetails: {
                                alignment: 'left'

                            },
                            invoiceBillingAddressTitle: {
                                margin: [0, 7, 0, 3],
                                bold: true
                            },
                            invoiceBillingAddress: {

                            },
                            // Items Header
                            itemsHeader: {

                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true
                            },
                            // Item Title
                            itemTitle: {
                                bold: true,
                            },
                            itemSubTitle: {
                                //italics: true,
                                fontSize: 10
                            },
                            itemText: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                            },
                            itemNumber: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'right',
                            },
                            itemTotal: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },

                            // Items Footer (Subtotal, Total, Tax, etc)
                            itemsFooterSubTitle: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterSubValue: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            itemsFooterTotalTitle: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterTotalValue: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            signaturePlaceholder: {
                                fontSize: 10,
                                margin: [0, 70, 0, 0],
                            },
                            signatureName: {
                                fontSize: 10,
                                margin: [0, 10, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            signatureJobTitle: {
                                fontSize: 10,
                                margin: [0, 20, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            notesTitle: {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 30, 0, 3],
                            },
                            notesText: {
                                fontSize: 10
                            },
                            center: {
                                alignment: 'center',
                            },
                        },
                        defaultStyle: {
                            columnGap: 20,
                            font:'ukai'
                        }
                    }
                    pdfMake.createPdf(dd).open();
                },
        retrieveWTO()
        {
            if (this.wtr.wto_num != '')
            {
                this.isWTORetrieved = true
            }

        },
        rowClick(item, index)
        {
            localStorage.setItem("wtr_new.wto_num", item.wto_num)
            this.$router.push({ name: 'Warehouse Transfer Receiving (WTR)', params: { wtrNum: '_new' }})
        },
        cancelWtr()
        {
            this.wtr.wto_num = "";
            this.isWTORetrieved = false;
        },
        setWtoId(obj)
        {
            if (obj !== null)
            {
                let curDate = new Date()
                curDate = curDate.toISOString().substr(0,10)
                this.wtr.wtr_date = curDate
                this.wtr.wto = obj
                this.wtr.wto_num = obj.wto_num
            }
            else
            {
                this.wtr.wto_num = null
            }

        },
        validateUpdateQtyEntries(index)
        {
            var updateQty
            updateQty = this.wtr.wto.wto_items[index].qty_received_current *1
            var requestedQty
            requestedQty = this.wtr.wto.wto_items[index].qty*1
            var receivedQty = this.wtr.wto.wto_items[index].qty_received*1
            var maxAcceptedQty = requestedQty - receivedQty
            if (updateQty<0)
            {
                this.errorMessage = "Update WTR Quantity Value must not be a negative number"
                this.$refs.myErrorModalRef.show()
              // this.wtr.wto.wto_items[index].qty_received_current = 0
            }
            else if(updateQty > maxAcceptedQty)
            {
               // alert("Update Qty > MaxAcceptedQty")
                this.errorMessage = "Update WTR Quantity Value must not exceed the requested of the WTO Qty"
                this.$refs.myErrorModalRef.show()
               //this.wtr.wto.wto_items[index].qty_received_current = 0
            }

        },
        confirmSave()
        {
            this.modalShow = true
        },
        save()
        {
            if(1)
            {
                axios.post(apiWtrSave, this.wtr, authHeader())
                        .then (res => {
                        var r = res.data

                        if (r.code == 1)
                        {
                            this.wtrDocNo = r.data.wtr_num
                            this.$refs.myModalRef.show()
                        }
                        else
                        {
                            this.errorMessage = r.msg
                            this.$refs.myErrorModalRef.show()
                        }
                        })
                .catch(error => alert(error))

            }

        },
        confirmCancel()
        {
           this.modalCancelShow = true
        },
        cancel()
        {
            this.$router.push({ name: 'Warehouse Transfer Receivings (WTRS)'})
        },
        back()
        {
            this.$router.push({ name: 'Warehouse Transfer Receivings (WTRS)'})
        },
        hideModal ()
        {
            this.$refs.myModalRef.hide()
            this.$router.push({ name: 'Warehouse Transfer Receivings (WTRS)'})
        },
        hideErrorModal()
        {
            this.$refs.myErrorModalRef.hide()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/wtr/wtr.vue